module.exports = __webpack_public_path__ + "static/img/xngs.02ba2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/image/xngs.png
// module id = DreA
// module chunks = 1